/** @format */

export const content = {
  month: {
    title: 'Фактически потраченная сумма за актуальный период.',
    descriptions: [
      'При заполненном медиаплане показывает расход с начала текущего периода.',
      'Без медиаплана - с начала календарного месяца.',
    ],
  },
  yesterday: {
    title: 'Фактически потраченная сумма за вчерашний день.',
    descriptions: [
      'При заполненном медиаплане сравнивает значение со среднесуточным.',
      'Без медиаплана показывает дельту с расходом за позавчера.',
    ],
  },
};
